import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 16,
		height: 16,
		backgroundColor: 'transparent',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function FeaturedPlayListIcon(props) {
	return (
		<svg style={{ width: 16, height: 16 }} width="16" height="16" class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<FeaturedPlayListIcon fill={props.fill} />
		</div>
	);
}